// extracted by mini-css-extract-plugin
export default {"tabletImg":"yQ","desktopImg":"zQ","mobileImg":"AQ","backgroundImage":"BQ","content":"CQ","rtbLeft":"EQ","rtbRight":"FQ","imageContainer":"GQ","rtbBox":"HQ","line":"IQ"};
    if(module.hot) {
      // 1730991509048
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  